
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import axios from "axios";
import { MstCouponVO } from "../coupon/vo/coupon.vo";
@Component
export default class MyProducts extends Vue {
  currentTabIdx = 99;

  coupons = [] as Array<MstCouponVO>;

  created() {
    axios.get("/coupon/my-coupons").then((r) => {
      this.coupons = r.data;
    });
  }

  convertFormat(date: string): string {
    const target = date.split(" ");
    if(target.length != 2) return date;
    const time = (target[target.length-1]??"").split(":")||[];
    if(time.length != 3) return date;
    return target[0].concat(` ${parseInt(time[0])}시`);
  }
}
